import {
	MaskedPhoneNumberInputSchema,
	SchemaBuilder,
	SingleCheckboxSchema,
	TextInputSchema,
} from '@aspendental/shared-forms-web';

const firstNameSchema = TextInputSchema.options.default;
const lastNameSchema = TextInputSchema.options.default;
const phoneNumberSchema = MaskedPhoneNumberInputSchema.options.default;
const emailAddressSchema = TextInputSchema.options.email;
const receiveTransactionalSMSCheckboxSchema = SingleCheckboxSchema.options.default;
const receiveMarketingSMSCheckboxSchema = SingleCheckboxSchema.options.default;

export const personalInformationStepForm = {
	firstName: {
		name: 'firstName',
		label: 'FIRST NAME',
		schema: firstNameSchema,
	},
	lastName: {
		name: 'lastName',
		label: 'LAST NAME',
		schema: lastNameSchema,
	},
	phoneNumber: {
		name: 'phoneNumber',
		label: 'PHONE NUMBER',
		schema: phoneNumberSchema,
	},
	emailAddress: {
		name: 'emailAddress',
		label: 'E-MAIL ADDRESS',
		schema: emailAddressSchema,
	},
	receiveTransactionalSMSCheckbox: {
		name: 'receiveTransactionalSMSCheckbox',
		label: 'I consent to receive automated informational (appt confirmations, reminders) text messages from Chapter Aesthetic Studio at the number I provided. Consent is not required. Opt-out any time by calling 888-651-9950 or replying “STOP.” Msg & data rates may apply.',
		schema: receiveTransactionalSMSCheckboxSchema,
	},
	receiveMarketingSMSCheckbox: {
		name: 'receiveMarketingSMSCheckbox',
		label: 'I consent to receive automated marketing (offers, discounts) text messages from Chapter Aesthetic Studio at the number I provided. Consent is not required. Opt-out any time by calling 888-651-9950 or replying “STOP.” Msg & data rates may apply.',
		schema: receiveMarketingSMSCheckboxSchema,
	},
};

export const personalInformationStepFormSchema = SchemaBuilder([
	{ name: personalInformationStepForm.firstName.name, validation: personalInformationStepForm.firstName.schema },
	{ name: personalInformationStepForm.lastName.name, validation: personalInformationStepForm.lastName.schema },
	{ name: personalInformationStepForm.phoneNumber.name, validation: personalInformationStepForm.phoneNumber.schema },
	{
		name: personalInformationStepForm.emailAddress.name,
		validation: personalInformationStepForm.emailAddress.schema,
	},
	{
		name: personalInformationStepForm.receiveTransactionalSMSCheckbox.name,
		validation: personalInformationStepForm.receiveTransactionalSMSCheckbox.schema,
	},
	{
		name: personalInformationStepForm.receiveMarketingSMSCheckbox.name,
		validation: personalInformationStepForm.receiveMarketingSMSCheckbox.schema,
	},
]);
